import { useState } from "react";
import defaultTenant from "components/tenants/constants/defaultTenant";
import { ITenant } from "../../components/tenants/types";

interface UseTenantFormProps {
  onSave: (tenant: ITenant) => void;
}

export const useTenantForm = ({ onSave }: UseTenantFormProps) => {
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formState, setFormState] = useState<ITenant>(defaultTenant);

  const openCreateModal = () => {
    setFormState(defaultTenant);
    setIsEditMode(false);
    setShowModal(true);
  };

  const openEditModal = (tenant: ITenant) => {
    if (!tenant) return;
    setFormState(tenant);
    setIsEditMode(true);
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const handleSubmit = (data: ITenant) => {
    onSave(data);
    closeModal();
  };

  return {
    showModal,
    isEditMode,
    formState,
    openCreateModal,
    openEditModal,
    closeModal,
    handleSubmit,
  };
};
